/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starter_Challenge_Complete_TitleInputs */

const en_starter_challenge_complete_title = /** @type {(inputs: Starter_Challenge_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Congratulations!`)
};

const ar_starter_challenge_complete_title = /** @type {(inputs: Starter_Challenge_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تهانينا!`)
};

const de_starter_challenge_complete_title = /** @type {(inputs: Starter_Challenge_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herzlichen Glückwunsch!`)
};

const es_starter_challenge_complete_title = /** @type {(inputs: Starter_Challenge_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Felicidades!`)
};

const fr_starter_challenge_complete_title = /** @type {(inputs: Starter_Challenge_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Félicitations !`)
};

const it_starter_challenge_complete_title = /** @type {(inputs: Starter_Challenge_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Congratulazioni!`)
};

const ja_starter_challenge_complete_title = /** @type {(inputs: Starter_Challenge_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`おめでとうございます！`)
};

const ko_starter_challenge_complete_title = /** @type {(inputs: Starter_Challenge_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`축하합니다!`)
};

const pt_br_starter_challenge_complete_title = /** @type {(inputs: Starter_Challenge_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parabéns!`)
};

const ru_starter_challenge_complete_title = /** @type {(inputs: Starter_Challenge_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поздравляем!`)
};

const th_starter_challenge_complete_title = /** @type {(inputs: Starter_Challenge_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ขอแสดงความยินดีด้วย!`)
};

const tr_starter_challenge_complete_title = /** @type {(inputs: Starter_Challenge_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tebrikler!`)
};

const zh_cn_starter_challenge_complete_title = /** @type {(inputs: Starter_Challenge_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`恭喜完成挑战！`)
};

const zh_tw_starter_challenge_complete_title = /** @type {(inputs: Starter_Challenge_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`恭喜完成挑戰！`)
};

/**
* | output |
* | --- |
* | "Congratulations!" |
*
* @param {Starter_Challenge_Complete_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const starter_challenge_complete_title = /** @type {((inputs?: Starter_Challenge_Complete_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starter_Challenge_Complete_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starter_challenge_complete_title(inputs)
	if (locale === "ar") return ar_starter_challenge_complete_title(inputs)
	if (locale === "de") return de_starter_challenge_complete_title(inputs)
	if (locale === "es") return es_starter_challenge_complete_title(inputs)
	if (locale === "fr") return fr_starter_challenge_complete_title(inputs)
	if (locale === "it") return it_starter_challenge_complete_title(inputs)
	if (locale === "ja") return ja_starter_challenge_complete_title(inputs)
	if (locale === "ko") return ko_starter_challenge_complete_title(inputs)
	if (locale === "pt_br") return pt_br_starter_challenge_complete_title(inputs)
	if (locale === "ru") return ru_starter_challenge_complete_title(inputs)
	if (locale === "th") return th_starter_challenge_complete_title(inputs)
	if (locale === "tr") return tr_starter_challenge_complete_title(inputs)
	if (locale === "zh_cn") return zh_cn_starter_challenge_complete_title(inputs)
	return zh_tw_starter_challenge_complete_title(inputs)
});